import * as React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// Bucharest is the default city, so it only adds noise (ş and ș are both used in the data)
const HOME_CITY = '(?:Bucure[şșs]ti|Bucharest)';
// Only strip it as a clear prefix ("București, ...", "București - ...", "București ...") or a
// ", București" suffix, so street names like "Calea București" or "Bucureștii Noi" stay intact
const LEADING_CITY = new RegExp(`^${HOME_CITY}(?:\\s*,\\s*|\\s+-\\s+|\\s+)`, 'i');
const TRAILING_CITY = new RegExp(`\\s*,\\s*${HOME_CITY}$`, 'i');

const cleanAddress = (value: string | null | undefined) => {
  const cleaned = (value || '')
    // Some addresses arrive with a literal "undefined" where a street number was missing
    .replace(/\bundefined\b/g, '')
    .replace(/\s{2,}/g, ' ')
    .trim();

  const withoutCity = cleaned.replace(LEADING_CITY, '').replace(TRAILING_CITY, '');

  // Keep the city when it is the whole address
  return withoutCity || cleaned;
};

const pointRole = (index: number, total: number) => {
  if (index === 0) return 'pickup';
  if (index === total - 1) return 'destination';
  return 'stop';
};

const BottomSlide = (): JSX.Element => {
  const { order: orderState } = useSelector((state: CR.RootState) => state.order);

  const order = orderState as CR.OrderCRUD;

  return (
    <div className="details">
      <h2 className="details__title">
        <FormattedMessage id="trip" />
      </h2>

      <ol className="route">
        {order.route_points?.map((point, index, array) => {
          const role = pointRole(index, array.length);
          const name = cleanAddress(point.name);
          const address = cleanAddress(point.address_name);

          return (
            // eslint-disable-next-line react/no-array-index-key
            <li className={`route__point route__point--${role}`} key={index}>
              <span className="route__marker" aria-hidden="true" />
              <span className="route__role">
                <FormattedMessage id={`route_${role}`} />
              </span>
              <span className="route__name">{name}</span>
              {address && address !== name && (
                <span className="route__address">{address}</span>
              )}
            </li>
          );
        })}
      </ol>

      <a href="https://bit.ly/TaxiMer" target="_blank" rel="noreferrer" className="installButton">
        <img className="installButton__logo" src="/assets/logo-taxi.png" alt="" />
        <FormattedMessage id="install_meridian" />
      </a>
    </div>
  );
};

export default BottomSlide;
